<template>
    <div>
        <div v-if="isBestPractice">
            <p class="-color-red-1">{{$t('COMPLIANCE.POPUP.DESC.REMOVE_BEST_PRACTICE')}}</p>
        </div>
        <div class="plcy-list">
            <ul>
                <li v-for="(plcy, idx) in plcyList" :key="idx" :class="plcy.userDefiYn == constants.PARAM.SELECT.N ? '-color-red-1': ''">
                    {{ getPlcyTitle(plcy) }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "PlcyListToRemove",
    props: {
        plcyList: Array,
    },
    computed: {
        isBestPractice: function() {
            let isBestPractice = false;
            (this.plcyList || []).forEach(element => {
                if (element.userDefiYn == this.constants.PARAM.SELECT.N) {
                    isBestPractice = true;
                    return;
                }
            });
            return isBestPractice;
        }
    },
    methods: {
        getPlcyTitle(obj) {
            const objTitle = obj.userDefiYn == this.constants.PARAM.SELECT.N ? obj[this.$i18n.locale+'Title'] : obj.titl;
            return objTitle;
        }
    }
}
</script>
<style scoped>
.plcy-list {
    margin-left: 30px;
}
.plcy-list li {
    list-style: auto;
    margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/compliance/components/PlcyListToRemove.vue